/* PARFUMPROBEN VERSAND – Größen-Wähler im Warenkorb (gehört zu snippets/ppv-cart-size.liquid).
   Ein Tipp auf eine andere Größe tauscht die Variante der Zeile und behält die Menge: eine Anfrage an
   /cart/update.js (alte Zeile 0, neue Größe dazu – liegt sie schon im Warenkorb, kommt die Menge dort dazu),
   danach wird der Einschub so neu gezeichnet wie bei Dawns Mengenänderung. */
(() => {
  if (window.__PPV_CART_SIZE__) return;
  window.__PPV_CART_SIZE__ = true;

  const ERROR_TEXT = 'Die Größe ließ sich gerade nicht ändern. Bitte versuch es noch einmal.';
  const STOCK_TEXT = 'Von dieser Größe ist nicht mehr genug da – die Menge wurde angepasst.';
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  let busy = false;

  const routes = () => window.routes || {};
  const calm = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  const post = (url, body) =>
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((response) =>
      response
        .json()
        .catch(() => null)
        .then((data) => {
          if (!response.ok || !data) {
            const message = data && (data.description || data.message || data.errors);
            throw new Error(typeof message === 'string' && message ? message : ERROR_TEXT);
          }
          return data;
        })
    );

  /* Scrollt die Liste selbst (cart-drawer-items) oder – auf niedrigen Bildschirmen – der ganze Einschub? */
  const scrollerOf = (drawer) => {
    const items = drawer.querySelector('cart-drawer-items');
    if (items && getComputedStyle(items).overflowY !== 'visible') return items;
    return drawer.querySelector('.drawer__inner');
  };

  const offsetIn = (scroller, element) =>
    element.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;

  const formatDiff = (cents, symbol) => {
    const abs = Math.abs(cents);
    const amount = abs % 100 === 0 ? String(abs / 100) : (abs / 100).toFixed(2).replace('.', ',');
    return `${cents > 0 ? '+' : '−'}${amount} ${symbol}`;
  };

  /* Sofort zeigen, was gewählt wurde: Daumen umsetzen, Preisunterschiede neu rechnen. Breite und Höhe bleiben. */
  const preview = (group, chosen) => {
    const price = Number(chosen.dataset.ppvSizePrice);
    const ratio = Number(group.dataset.ppvSizeRatio) || 1;
    const symbol = group.dataset.ppvSizeSymbol || '€';
    group.querySelectorAll('.ppv-size-switch__o').forEach((option) => {
      const on = option === chosen;
      option.setAttribute('aria-pressed', String(on));
      let diff = option.querySelector('.ppv-size-switch__d');
      const cents = Math.round((Number(option.dataset.ppvSizePrice) - price) * ratio);
      if (on || option.disabled || !cents) {
        if (diff) diff.remove();
        return;
      }
      if (!diff) {
        diff = document.createElement('span');
        option.appendChild(diff);
      }
      diff.className = `ppv-size-switch__d${cents > 0 ? ' ppv-size-switch__d--up' : ''}`;
      diff.textContent = formatDiff(cents, symbol);
    });
  };

  const setBusy = (group, row, on) => {
    group.setAttribute('aria-busy', String(on));
    group.querySelectorAll('.ppv-size-switch__o').forEach((option) => {
      if (on) option.setAttribute('aria-disabled', 'true');
      else option.removeAttribute('aria-disabled');
    });
    if (row) row.querySelectorAll('.loading__spinner').forEach((spinner) => spinner.classList.toggle('hidden', !on));
    const items = document.getElementById('CartDrawer-CartItems');
    if (items) items.classList.toggle('cart__items--disabled', on);
    const status = document.getElementById('CartDrawer-LineItemStatus');
    if (status) status.setAttribute('aria-hidden', String(!on));
  };

  const showError = (index, message) => {
    const box = document.getElementById(`CartDrawer-LineItemError-${index}`);
    const text = box && box.querySelector('.cart-item__error-text');
    if (text) text.textContent = message;
  };

  /* Wie Dawns Mengenänderung: nur den Inhalt von .drawer__inner tauschen (der Einschub bleibt offen) und die
     Warenkorb-Blase aktualisieren. */
  const render = async (drawer, state) => {
    let html = state.sections && state.sections['cart-drawer'];
    if (!html) {
      const response = await fetch(`${routes().cart_url || '/cart'}?section_id=cart-drawer`, { credentials: 'same-origin' });
      html = await response.text();
    }
    const fresh = parse(html).querySelector('.drawer__inner');
    const inner = drawer.querySelector('.drawer__inner');
    if (!fresh || !inner) return false;
    inner.innerHTML = fresh.innerHTML;
    drawer.classList.toggle('is-empty', state.item_count === 0);
    const bubbleHtml = state.sections && state.sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    const bubbleSection = bubbleHtml && parse(bubbleHtml).querySelector('.shopify-section');
    if (bubble && bubbleSection) bubble.innerHTML = bubbleSection.innerHTML;
    return true;
  };

  /* Wächst der Gratisproben-Block oben (neue Meldung nach dem Abgleich), während er schon aus dem Bild gescrollt
     ist, bleibt die Liste trotzdem ruhig stehen. */
  const holdWhileAboveGrows = (scroller) => {
    const block = scroller && scroller.querySelector('ppv-cart-rewards');
    if (!block || !window.ResizeObserver) return;
    let last = block.offsetHeight;
    const observer = new ResizeObserver(() => {
      const height = block.offsetHeight;
      const delta = height - last;
      last = height;
      if (!delta) return;
      const bottomBefore = block.getBoundingClientRect().bottom - delta;
      if (bottomBefore <= scroller.getBoundingClientRect().top + 1) scroller.scrollTop += delta;
    });
    observer.observe(block);
    setTimeout(() => observer.disconnect(), 2500);
  };

  const reveal = (scroller, row) => {
    if (!scroller) return;
    const box = scroller.getBoundingClientRect();
    const rect = row.getBoundingClientRect();
    let delta = 0;
    if (rect.top < box.top + 8) delta = rect.top - box.top - 8;
    else if (rect.bottom > box.bottom - 8) delta = Math.min(rect.bottom - box.bottom + 8, rect.top - box.top - 8);
    if (delta) scroller.scrollBy({ top: delta, behavior: calm() ? 'auto' : 'smooth' });
  };

  const flash = (row) => {
    row.classList.remove('ppv-size-moved');
    void row.offsetWidth;
    row.classList.add('ppv-size-moved');
    row.addEventListener('animationend', () => row.classList.remove('ppv-size-moved'), { once: true });
  };

  const change = async (drawer, group, option) => {
    busy = true;
    const row = group.closest('.cart-item');
    const index = group.dataset.ppvSizeIndex;
    const lineKey = group.dataset.ppvSizeLine;
    const current = group.dataset.ppvSizeCurrent;
    const quantity = Number(group.dataset.ppvSizeQty) || 1;
    const variant = option.dataset.ppvSizeVariant;
    const target = option.dataset.ppvSizeTarget || variant;
    const wanted = Number(option.dataset.ppvSizeTargetQty) || quantity;
    const hadFocus = group.contains(document.activeElement);
    const snapshot = group.innerHTML;
    const scroller = scrollerOf(drawer);
    const table = drawer.querySelector('.cart-items');
    const before = {
      scroll: scroller ? scroller.scrollTop : 0,
      table: scroller && table ? offsetIn(scroller, table) : 0,
    };

    showError(index, '');
    preview(group, option);
    setBusy(group, row, true);

    let state;
    let note = '';
    let restored = false;
    try {
      state = await post(routes().cart_update_url || '/cart/update', {
        updates: { [lineKey]: 0, [target]: wanted },
        sections: SECTIONS,
        sections_url: window.location.pathname,
      });
      const items = state.items || [];
      const got = items
        .filter((item) => String(item.variant_id) === String(variant))
        .reduce((sum, item) => sum + item.quantity, 0);
      if (!got && !items.some((item) => item.key === lineKey)) {
        /* Neue Größe kam nicht in den Warenkorb, die alte ist schon weg: alte Zeile zurücklegen. */
        state = Object.assign(
          await post(routes().cart_add_url || '/cart/add', {
            items: [{ id: Number(current), quantity }],
            sections: SECTIONS,
            sections_url: window.location.pathname,
          }),
          { item_count: 1 }
        );
        restored = true;
        note = ERROR_TEXT;
      } else if (got < wanted) {
        note = STOCK_TEXT;
      } else if (typeof state.errors === 'string' && state.errors) {
        note = state.errors;
      }
    } catch (error) {
      group.innerHTML = snapshot;
      setBusy(group, row, false);
      showError(index, (error && error.message) || ERROR_TEXT);
      busy = false;
      if (hadFocus) {
        const back = group.querySelector(`[data-ppv-size-variant="${variant}"]`);
        if (back) back.focus({ preventScroll: true });
      }
      return;
    }

    try {
      if (!(await render(drawer, state))) throw new Error(ERROR_TEXT);
    } catch (error) {
      window.location.reload();
      return;
    }

    /* Erst im nächsten Bild messen: dann steckt der Gratisproben-Block (ppv-cart-rewards.js) wieder in der Liste. */
    requestAnimationFrame(() => {
      const nextScroller = scrollerOf(drawer);
      const nextTable = drawer.querySelector('.cart-items');
      if (nextScroller && nextTable) nextScroller.scrollTop = before.scroll + (offsetIn(nextScroller, nextTable) - before.table);
      holdWhileAboveGrows(nextScroller);

      const shown = restored ? current : variant;
      const nextGroup = drawer.querySelector(`.ppv-size-switch[data-ppv-size-current="${shown}"]`);
      const quantityInput = drawer.querySelector(`.quantity__input[data-quantity-variant-id="${shown}"]`);
      const nextRow = (nextGroup && nextGroup.closest('.cart-item')) || (quantityInput && quantityInput.closest('.cart-item'));

      /* Fokusfalle des Einschubs auffrischen, ohne die Liste zu bewegen, dann den Fokus zurück auf den Wähler. */
      const container = document.getElementById('CartDrawer');
      if (typeof trapFocus === 'function' && container) trapFocus(container, drawer.querySelector('.drawer__inner') || container);
      if (nextRow && nextRow.id !== `CartDrawer-Item-${index}`) {
        reveal(nextScroller, nextRow);
        flash(nextRow);
      }
      if (hadFocus && nextGroup) {
        const pressed = nextGroup.querySelector('[aria-pressed="true"]');
        if (pressed) pressed.focus({ preventScroll: true });
      }
      if (note && nextRow) showError(nextRow.id.replace('CartDrawer-Item-', ''), note);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state, variantId: variant });
      }
      busy = false;
    });
  };

  document.addEventListener('click', (event) => {
    const option = event.target.closest && event.target.closest('.ppv-size-switch__o');
    if (!option) return;
    const group = option.closest('.ppv-size-switch');
    const drawer = option.closest('cart-drawer');
    if (!group || !drawer) return;
    event.preventDefault();
    if (
      busy ||
      option.disabled ||
      !option.dataset.ppvSizeVariant ||
      option.getAttribute('aria-pressed') === 'true' ||
      option.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }
    change(drawer, group, option);
  });
})();
